import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import topNavigationBar from '/src/components/top-bar.vue'
import request from "./router/request";
import { apiUrl } from "./router/apiUrl";
import clipboard from 'clipboard'



router.beforeEach((to, from, next) => {

    // chrome

    document.body.scrollTop = 0

    // firefox

    document.documentElement.scrollTop = 0

    // safari

    window.pageYOffset = 0

    next()

})


Vue.config.productionTip = false

Vue.prototype.$api = request
Vue.prototype.$apiUrl = apiUrl
Vue.prototype.clipboard = clipboard;


Vue.use(ElementUI);
Vue.component('top-navigation-bar', topNavigationBar)

new Vue({
    el: '#app',
    router,
    render: h => h(App)
});